


























import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';
//@ts-ignore
import BvEvent from 'bootstrap-vue/src/utils/bv-event.class';

//Boostrap.vueのModalの代替して階層化表示機能を提供

@Component
export default class BootstrapModal extends Vue {
  @Prop({ default: false }) public value : boolean;
  @Prop({default:''}) public title : string;
  @Prop({default:'OK'}) public okTitle : string;
  @Prop({default:'Cancel'}) cancelTitle :string;
  @Prop({default:false, type:Boolean}) public okOnly : boolean;
  @Prop({default:false, type:Boolean}) public hideHeader :boolean;
  @Prop({default:false, type:Boolean}) public hideFooter :boolean;
  @Prop({default:false, type:Boolean}) public hideHeaderClose :boolean;  
  @Prop({default:false, type:Boolean}) public visible :boolean;  //固定表示用
  @Prop({default:true, type:Boolean}) public noCloseOnBackdrop:boolean; //ダミー(固定実装済み)
  @Prop({default:true, type:Boolean}) public centered:boolean; //ダミー(固定実装済み)
  @Prop({default:null}) public  returnFocus:any; //ダミー (実装省略) 
  @Prop({default:null}) public html: string;

  //実装イベント=>ok hidden hide cancel shown
  //実装不要プロパティ=>key/class
  //未実装プロパティ=>return-focus
  //未実装プロパティ(キャンペーン・フィードバックフォーム) =>size/header-class/body-class
  
  public mounted(){
      this.onValueChanged();
  }

  @Watch('value')
  public onValueChanged(){
      if (this.value) {
        //shownイベントはフォーカスに使用していたため、ここで実装
        // this.$emit('shown');
        this.$nextTick(()=>{
            ((this.$refs.footer as HTMLElement).lastChild as HTMLElement).focus();
        });
      }
  }
  public close(){    
    //v-modelを更新する
    this.$emit('hide');//visibleを使用している場合など
    if(this.value) this.$emit('input',false);  //v-model              
    this.$emit('hidden'); //matter_rptでしか使用していない
  }

  public onCancel(){
    var arg = this.createEventArg();      
    this.$emit('cancel',arg);
    if (arg.defaultPrevented == false) this.close();    
  }

  public onOk(){
    var arg = this.createEventArg();
    this.$emit('ok',arg);
    if (arg.defaultPrevented == false) this.close();    
  }

  public createEventArg(){
      return new BvEvent('hide', {
        cancelable: true,
        vueTarget: this,
        target: this.$refs.modal,
        // modalId: this.safeId(),
        relatedTarget: null
      });

  }
}
